import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

/**
 * Draggable pegman that users drop onto roadmap nodes to trigger a what-if scenario.
 * Uses Framer Motion's built-in drag with dragSnapToOrigin.
 * On drop, uses document.elementFromPoint to detect which [data-whatif-target] was hit.
 */
const WhatIfPegman = ({ onDrop }) => {
  const pegmanRef = useRef(null);

  const handleDragEnd = (event, info) => {
    // info.point gives page-level coordinates, but elementFromPoint needs viewport coordinates
    const dropX = info.point.x - window.scrollX;
    const dropY = info.point.y - window.scrollY;

    // Temporarily hide the pegman so elementFromPoint finds the node below
    if (pegmanRef.current) {
      pegmanRef.current.style.visibility = 'hidden';
      pegmanRef.current.style.pointerEvents = 'none';
    }

    const elementBelow = document.elementFromPoint(dropX, dropY);

    if (pegmanRef.current) {
      pegmanRef.current.style.visibility = 'visible';
      pegmanRef.current.style.pointerEvents = 'auto';
    }

    if (!elementBelow) {
      return;
    }

    // Walk up the DOM to find a [data-whatif-target] attribute
    let target = elementBelow;
    while (target && target !== document.body) {
      const targetIndex = target.getAttribute('data-whatif-target');
      if (targetIndex !== null) {
        onDrop(parseInt(targetIndex, 10));
        return;
      }
      target = target.parentElement;
    }

  };

  return (
    <div className="flex items-center justify-center gap-3 py-3">
      <motion.div
        ref={pegmanRef}
        drag
        dragSnapToOrigin
        dragElastic={0.5}
        onDragEnd={handleDragEnd}
        whileDrag={{ scale: 1.2, zIndex: 9999 }}
        whileHover={{ scale: 1.1 }}
        className="flex items-center gap-2 px-4 py-2 bg-amber-50 border-2 border-amber-300 rounded-full cursor-grab active:cursor-grabbing shadow-md select-none"
        style={{ touchAction: 'none', zIndex: 50 }}
      >
        <MapPin size={18} className="text-amber-600" />
        <span className="text-xs font-bold text-amber-700 uppercase tracking-wide">
          Drag to explore "What If"
        </span>
      </motion.div>
    </div>
  );
};

export default WhatIfPegman;
